import { ServiceLevel } from '@provision/service-level-utils';

export function filterSecurityOnlyOption<TOption extends { id: string }>(
  options: TOption[],
  canSetSecurityOnlySla: boolean,
): TOption[] {
  if (canSetSecurityOnlySla) {
    return options;
  }

  return options.filter((option) => (option.id as ServiceLevel) !== ServiceLevel.SecurityOnly);
}
